import "./About.module.css";
import YujuBranding from "@/reusable_sections/Header";
import CompanyOverview from "./sections/CompanyOverview";
import TeacherAndStaffDirectory from "./sections/TeacherAndStaffDirectory";
import OurPillarsOfVigilance from "./sections/OurPillarsOfVigilance";
import PagueIpvaMultasELicenciamentoSemSairDeCasam from "./sections/PagueIpvaMultasELicenciamentoSemSairDeCasam";
import OurCommitment from "./sections/OurCommitment";
import About from "./sections/About";
import GlobalPackagingLandscape from "./sections/GlobalPackagingLandscape";
import BharatVidyaFooter from "@/reusable_sections/Footer";
export default function AboutPage() {
  return <div>
      <YujuBranding />
      <CompanyOverview />
      <TeacherAndStaffDirectory />
      <OurPillarsOfVigilance />
      <PagueIpvaMultasELicenciamentoSemSairDeCasam />
      <OurCommitment />
      <GlobalPackagingLandscape />
      <About />
      <BharatVidyaFooter />
    </div>;
}